module.exports = __webpack_public_path__ + "img/logo_black-green-full.8d82ae25.png";